import { MEDIA_URL } from "@/services/api";
import { IBrands, IBrandsGeneric } from "global-types/global.types";
import Image from "next/image";
import Link from "next/link";
import { localePrefix } from "@/helper/helper";

interface Props {
  locale: string;
  data: IBrandsGeneric;
}

export default function Brands({ locale, data }: Props) {
  return (
    <Link
      href={`${localePrefix(locale)}/brand/${data.slug}`}
      className="brand-carousel-card"
    >
      <div className="img-container">
        <Image width={400} height={400} src={`${data.logo}`} alt={data.name} />
      </div>
      <div className="content">
        <div className="brand-name">{data.name}</div>
        {/* <div className="brand-desc">{data.about}</div> */}
      </div>
    </Link>
  );
}
